import React from "react";
import { Button, Spinner } from "react-bootstrap";
import { injectIntl } from 'react-intl';

function LoaderButton(
    {
        loading = false,
        intl,
        name,
        onButtonClick,
        valid = true,
        className,
        icon = null,
        style = {}
    }) 

    {
        const { formatMessage } = intl;

    return (
        <React.Fragment>
            {loading ?
                <Button
                    className={className || "btn btn-chartreuse btn-height btn-block"}
                    disabled
                    style={style}
                >
                    {icon && <i className={icon}></i>}
                    {formatMessage({ id: "app.loading" })}
                    <Spinner
                        className="ml-2"
                        animation="grow"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                    />
                </Button>
                :
                <Button
                    style={style}
                    className={className || "btn btn-chartreuse btn-height btn-block"}
                    disabled={!valid}
                    onClick={onButtonClick}>
                    {icon && <i className={icon}></i>}
                    {name}
                </Button>
            }
        </React.Fragment>
    );
}

export default injectIntl(LoaderButton);